import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function VideoMatrix() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);

  const formatViews = (v: number) => {
    if (v >= 10000) return (v / 10000).toFixed(1) + '万';
    return v.toString();
  };

  return (
    <section className="w-full bg-background-950 py-16 md:py-20" aria-labelledby="daily-heading">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <h2
            id="daily-heading"
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 mb-3"
          >
            每日猛料
            <br />
            视频矩阵
          </h2>
          <p className="text-base text-foreground-400">
            全网最新最热的吃瓜视频，每日实时更新
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-50 rounded-xl overflow-hidden hover:ring-2 hover:ring-primary-500/50 transition-all duration-300"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  {article.isNew && (
                    <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                      新
                    </span>
                  )}
                  <span className="px-2 py-0.5 bg-background-50/80 backdrop-blur-sm text-foreground-950 text-xs font-medium rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 bg-background-50/80 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-1">
                  <i className="ri-play-circle-fill text-primary-500 text-sm"></i>
                  <span className="text-xs text-foreground-950 font-medium">
                    {formatViews(article.views)}
                  </span>
                </div>
              </div>

              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-950 leading-snug mb-3 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {formatViews(article.views)}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {formatViews(article.comments)}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/chigua-remen"
            className="inline-flex items-center gap-2 px-8 py-3 border-2 border-background-300 text-foreground-300 font-medium text-sm rounded-full hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部猛料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}